import { useMemo } from "react";
import { BLOCKCHAINS, PROVIDERS, getBlockchainByChainId } from "./providers";
import { useAppDispatch, useAppSelector } from "../services/hooks.service";
import { PeraConnector } from "./algorand/pera.service";
import { SolanaConnector } from "./solana/solana.service";
import { EVMConnector } from "./evm/evm.service";
import { updateSelectedWallet } from "../redux/_actions/user.action";

export interface Wallet {
  address: string;
  provider: PROVIDERS;
  chain: BLOCKCHAINS;
}

const solanaConnector = SolanaConnector.getInstance();
const evmConnector = EVMConnector.getInstance();
const peraConnector = PeraConnector.getInstance();

export const useActiveAccount = () => {
  const dispatch = useAppDispatch();
  const network = useAppSelector(state => state.network);
  const {chain, provider, isConnected} = network;
  // console.log('useActiveAccount', {
  //   evmConnector: {...evmConnector},
  //   provider,
  //   solanaConnector: {...solanaConnector}
  // })

  const activeWallet = useMemo<Wallet | null>(() => {
    if (!isConnected) return null;
    if (provider === PROVIDERS.PERA) {
      const { address } = peraConnector;
      peraConnector.reconnect(address);
      dispatch(updateSelectedWallet(address));
      // console.log('Active wallet is PERA', { address })
      return { address, chain, provider };
    }

    if (provider === PROVIDERS.PHANTOM
      || provider === PROVIDERS.SOLFLARE
      || provider === PROVIDERS.COINBASE
      || provider === PROVIDERS.WALLET_CONNECT
      || provider === PROVIDERS.BACKPACK
      || provider === PROVIDERS.MOBILE
    ) {
      if (solanaConnector.isConnected && solanaConnector.address) {
        const address = solanaConnector.address;
        dispatch(updateSelectedWallet(address));
        // console.log('Active wallet is SOLANA', { address })
        return { address, chain, provider };
      } else {
        return null;
      }
    }

    if (evmConnector.isConnected && evmConnector.address) {
      const { address } = evmConnector;
      dispatch(updateSelectedWallet(address));
      // console.log('Active wallet is EVM', { address });
      return {
        address,
        provider: provider ?? PROVIDERS.METAMASK,
        chain: getBlockchainByChainId(evmConnector.chainId)
      };
    }

    return null;
  }, [chain, isConnected, provider, evmConnector.address, peraConnector.address, solanaConnector.address]);

  return activeWallet;
}
